import axios from 'axios';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

const SHOPIER_API_URL = process.env.REACT_APP_API_URL + '/shopier';

export const getPackagePrice = async () => {
  try {
    const settingsRef = doc(db, 'settings', 'premium');
    const settingsDoc = await getDoc(settingsRef);
    
    if (settingsDoc.exists()) {
      return settingsDoc.data().packagePrice;
    }
    return 50; // Varsayılan fiyat
  } catch (error) {
    console.error('Fiyat bilgisi alınırken hata:', error);
    return 50; // Hata durumunda varsayılan fiyat
  }
};

export const createShopierPayment = async (userData) => {
  try {
    // Güncel fiyatı al
    const price = await getPackagePrice();
    
    const response = await axios.post(`${SHOPIER_API_URL}/create-payment`, {
      buyer: {
        id: userData.uid,
        first_name: userData.displayName?.split(' ')[0] || 'Misafir',
        last_name: userData.displayName?.split(' ')[1] || 'Kullanıcı',
        email: userData.email,
        phone: userData.phoneNumber || '5555555555'
      },
      order_total: price, // Dinamik fiyat
      callback_url: `${window.location.origin}/payment/callback`
    });

    // Shopier form verilerini al
    const { formHtml } = response.data;
    
    // Geçici bir div oluştur ve form HTML'ini yerleştir
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = formHtml;
    
    // Formu otomatik submit et
    const form = tempDiv.querySelector('form');
    if (form) {
      document.body.appendChild(form);
      form.submit();
    }

  } catch (error) {
    console.error('Shopier ödeme hatası:', error);
    throw error;
  }
}; 